<div class="table-container">
    <table class="table text-center mb-0">
        <thead>
          <tr>
            <th scope="col" colspan="4">{{'reporting_people' | translate}} ({{people.total}})</th>
          </tr>
          <tr>
            <th scope="col"  colspan="2">{{'reporting_people.disabled' | translate}} ({{people.disabled}})</th>
            <th scope="col"  colspan="2">{{'reporting_people.enabled' | translate}} ({{people.total - people.disabled}})</th>
          </tr>
          <tr>
            <th scope="col">{{'reporting_people.bounced' | translate}}</th>
            <th scope="col">{{'reporting_people.manually_disabled' | translate}}</th>
            <th scope="col">{{'reporting_people.teammates' | translate}}</th>
            <th scope="col">{{'reporting_people.observers' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{people.bounced}}</td>
            <td>{{people.manuallyDisabled}}</td>
            <td>{{people.teammates}}</td>
            <td>{{people.observers}}</td>
          </tr>
        </tbody>
      </table>
    
</div>
